import React from 'react';
import { Link } from 'react-router-dom';

export default class SideNavigation extends React.Component {

  constructor(props) {
    super(props);

    this.pages = {
      'homepage': { 'name': 'Thinking', 'slug': 'thinking', 'href': '../' },
      'services': { 'name': 'Services', 'slug': 'services', 'href': '../services' },
      'expertise': { 'name': 'Expertise', 'slug': 'expertise', 'href': '../expertise' },
      'people': { 'name': 'People', 'slug': 'people', 'href': '../people' },
      'network': { 'name': 'Network', 'slug': 'network', 'href': '../network' },
      'news': { 'name': 'News', 'slug': 'news', 'href': '../news' }
    };
  }

  render() {
    var targetPage = this.props.targetPage ? this.pages[this.props.targetPage] : {};

    return (
      <div className={`SideNavigation ${this.props.direction} hidden-sm-down`}>
        <div className="line"></div>
        <div className="targetPage">
          <Link to={targetPage.href}>{targetPage.name}</Link>
        </div>
      </div>
    );
  }
};
